/**
 * GDI Content Area Utilities
 *
 * Many GDI fields use [ContentAreaItemModel] (content areas with DisplayOption/Tag/ContentLink.Expanded).
 * These helpers extract the expanded content from that pattern.
 */

/**
 * Extract the first expanded block from a ContentAreaItemModel array.
 * Used when a field accepts a single content reference via content area
 * (e.g., Link, PosterImage, Caption).
 *
 * @param {Array} contentArea - ContentAreaItemModel array from Optimizely
 * @returns {Object|null} - The expanded content object, or null
 */
export const getExpandedFromContentArea = (contentArea) => {
    if (!Array.isArray(contentArea) || contentArea.length === 0) return null
    return contentArea[0]?.ContentLink?.Expanded || null
}

/**
 * Extract all expanded blocks from a ContentAreaItemModel array.
 * Used when a field accepts multiple content references.
 *
 * @param {Array} contentArea - ContentAreaItemModel array from Optimizely
 * @returns {Array} - Array of expanded content objects
 */
export const getAllExpandedFromContentArea = (contentArea) => {
    if (!Array.isArray(contentArea)) return []
    return contentArea
        .map((item) => item?.ContentLink?.Expanded)
        .filter(Boolean)
}
